import { chakra, forwardRef, type HTMLChakraProps } from '@chakra-ui/system';

export const ToolLayer = forwardRef<HTMLChakraProps<'svg'>, 'svg'>(
  (props, ref) => (
    <chakra.svg
      ref={ref}
      position="absolute"
      inset={0}
      width="100%"
      height="100%"
      // No interaction with the tool layer
      pointerEvents="none"
      overflow="visible"
      {...props}
    />
  ),
);
ToolLayer.displayName = 'ToolLayer';
